import React from 'react';
import * as Sentry from '@sentry/react';

import ServerError from '../../containers/ServerError';
import { __DEBUG__ } from '../../config/constants';

import './style.scss';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI.
    return { hasError: true };
  }

  componentDidUpdate() {
    // This unsets errorstate after updating, but a page navigation triggers one re-render
    // of the previous child before rendering the new child, so the error pops up once more.
    // You need another update for the error to be gone.
    // This is only a visual issue in development.
    if (this.state.hasError === true) {
      this.state.hasError = false;
    }
  }

  componentDidCatch(error, info) {
    console.log('Exception caught. Error:', error);
    console.log('Exception caught. Info:', info);

    if (!__DEBUG__) {
      Sentry.captureException(error);
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <ServerError />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
